import React from "react";
var __jsx = React.createElement;
import classes from "./AffSection1.module.css";
import { useTranslation } from "@i18n";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { PageNamesEnum } from "@/routes/routes";
var AffSection1 = function AffSection1() {
  var affiliate = useFullPageData(PageNamesEnum.PAGE_NAME__AFFILIATE);
  var _useTranslation = useTranslation(["web_affiliate_program", "web_common"]),
    t = _useTranslation.t,
    tLong = _useTranslation.tLong;
  return /*#__PURE__*/React.createElement("section", {
    className: classes.AffiliateSection1
  }, /*#__PURE__*/React.createElement("div", {
    className: ["container", classes.containerMaxWidt].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, t("affiliate_program", {
    ns: "web_affiliate_program"
  })), /*#__PURE__*/React.createElement("strong", null, t("double_income_earn", {
    ns: "web_affiliate_program"
  }), /*#__PURE__*/React.createElement("br", null), t("money", {
    ns: "web_affiliate_program"
  })), /*#__PURE__*/React.createElement("p", null, tLong("affiliate/program-intro", {
    ns: "web_affiliate_program"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://syarah.trackier.com/register.html",
    className: ["redBtn", classes.mrkALink].join(" ")
  }, t("start_earning_today", {
    ns: "web_affiliate_program"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    width: "421px",
    height: "auto",
    src: affiliate.image_url,
    alt: t("affiliate_program", {
      ns: "web_affiliate_program"
    })
  })))));
};
export default AffSection1;